<div class="modal-header">
  <div class="header-content">
    <h5 class="modal-title">Detalles del depósito</h5>
    <div class="d-flex justify-content-start align-items-center">
      <span class="badge badge-primary mr-2">{{deposito?.codigo}}</span>
      <span class="text-primary">{{deposito?.tipoDeposito}}</span>
    </div>
  </div>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cancelar')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ul class="list-group">
    <li class="list-group-item d-flex justify-content-between align-items-center">
      <span class="list-title">Moneda</span>
      <span class="list-value">{{deposito?.moneda}}</span>
    </li>
    <li class="list-group-item d-flex justify-content-between align-items-center">
      <span class="list-title">Fecha Vencimiento</span>
      <span class="list-value">{{deposito?.fechaVencimiento | date: 'dd/MM/yyyy'}}</span>
    </li>
    <li class="list-group-item d-flex justify-content-between align-items-center">
      <span class="list-title">Capital</span>
      <span class="list-value">{{deposito?.monto| currency}}</span>
    </li>
  </ul>
</div>
